import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'

export class AutoFocusSemanticUiComponent extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    functionName: PropTypes.string,
    focus: PropTypes.bool,
  }

  static defaultProps = {
    focus: true,
  }

  ref = React.createRef()

  componentDidMount() {
    if (!this.props.focus) {
      return
    }

    if (this.props.functionName) {
      this.ref.current[this.props.functionName]()
    }
  }

  componentDidUpdate(prevProps) {
    const { focus, functionName } = this.props
    if (!prevProps.focus && focus && functionName) {
      setTimeout(() => this.ref.current[functionName]())
    }
  }

  render() {
    return React.cloneElement(React.Children.only(this.props.children), {
      ...removeInternalProps(this.props),
      ref: this.ref,
    })
  }
}

const removeInternalProps = R.omit(['children', 'functionName', 'focus'])



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/AutoFocusSemanticUiComponent.js